import { render, staticRenderFns } from "./shopDashboard.vue?vue&type=template&id=4c26a28e"
import script from "./shopDashboard.vue?vue&type=script&lang=js"
export * from "./shopDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports